<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lefticonrighttext',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <div class="content-box flex align-center justify-center padding" >
              <a-image  v-if="item.icon" :src="addip(item.icon)" :alt="item.name" width="80px" />
              <div class="flex1 padding-left">
                <h3 style="">{{ item.name }}</h3>
                <h5 v-if="item.sub">{{ item.sub }}</h5>
              </div>
              <a :href="item.url" v-if="item.url">
                <h3><ArrowRightOutlined /></h3>
              </a>
            </div>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="lefticonrighttext">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
import { ArrowRightOutlined } from '@ant-design/icons-vue';
defineProps({
  data:Object
})
</script>
